enum DDOfferTierStatus {
    NotAccepted = 0,
    Accepted = 1,
    Declined = 2,
}
export default DDOfferTierStatus;
